export enum MoveDirection {
  UP = "UP",
  DOWN = "DOWN"
}
